import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../helper/BaseUrl";

const ProtectedRoute = ({ children }) => {
  const [isValid, setIsValid] = useState(null);
  const token = localStorage.getItem("AccessTokenTms");

  useEffect(() => {
    let interval;

    const verifyUser = async () => {
      try {
        await axios.get(`${BaseUrl}verify-user`, {
          headers: {
            "x-access-token": token,
          },
        });

        setIsValid(true);
      } catch (error) {
        const status = error.response?.status;
        if (status === 401 || status === 403) {
          localStorage.removeItem("AccessTokenTms");
          setIsValid(false);
          return;
        }

        setIsValid(true);
      }
    };

    if (token) {
      // 👉 First time check
      verifyUser();

      // 👉 Every 1 hour check
      interval = setInterval(() => {
        verifyUser();
      }, 3600000); // 1 hour
    } else {
      setIsValid(false);
    }

    // 👉 Cleanup (VERY IMPORTANT)
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [token]);

  // ⏳ While checking
  if (isValid === null) {
    return <div>Loading...</div>;
  }

  // ❌ Not valid → redirect
  if (!isValid) {
    return <Navigate to="/login" />;
  }

  // ✅ Valid
  return children;
};

export default ProtectedRoute;
